export default __webpack_public_path__ + "static/5-help-50984e46fb9477baf0ebb66addcf91bd.jpg";